var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailInfo",
              attrs: { title: "설비 기본정보", collapsed: true },
            },
            [
              _c(
                "template",
                { slot: "card-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable &&
                      _vm.popupParam.noPlan === "Y" &&
                      !_vm.updateMode &&
                      !_vm.disabled
                        ? _c("c-btn", {
                            attrs: { label: "설비선택", icon: "add" },
                            on: { btnClicked: _vm.add },
                          })
                        : _vm._e(),
                      _vm.editable && _vm.updateMode && !_vm.disabled
                        ? _c("c-btn", {
                            attrs: {
                              showLoading: false,
                              label: "점검완료",
                              icon: "save",
                              color: "blue",
                            },
                            on: { btnClicked: _vm.resultComplete },
                          })
                        : _vm._e(),
                      _vm.editable && !_vm.disabled
                        ? _c("c-btn", {
                            attrs: {
                              url: _vm.saveUrl,
                              isSubmit: _vm.isSave,
                              param: _vm.result,
                              mappingType: _vm.saveType,
                              label: "점검결과 저장",
                              icon: "save",
                            },
                            on: {
                              beforeAction: _vm.saveInspection,
                              btnCallback: _vm.saveCallback,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("template", { slot: "card-detail" }, [
                _vm.editable && !_vm.result.equipmentCd
                  ? _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("c-label-text", {
                          attrs: { title: "설비를 선택하세요." },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.editable && _vm.result.plantNm
                  ? _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-label-text", {
                          attrs: { title: "사업장", value: _vm.result.plantNm },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.editable && _vm.result.equipmentTypeCd
                  ? _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-label-text", {
                          attrs: {
                            title: "설비유형",
                            value: _vm.result.equipmentTypeNm,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.editable && _vm.result.equipmentCd
                  ? _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-label-text", {
                          attrs: {
                            title: "설비코드",
                            value: _vm.result.equipmentCd,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.editable && _vm.result.equipmentName
                  ? _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-label-text", {
                          attrs: {
                            title: "설비명",
                            value: _vm.result.equipmentName,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.editable && _vm.result.recentInspectionDate
                  ? _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-label-text", {
                          attrs: {
                            title: "이전점검일",
                            value: _vm.result.recentInspectionDate,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.editable && _vm.result.inspectionCycleName
                  ? _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-label-text", {
                          attrs: {
                            title: "점검주기",
                            value: _vm.result.inspectionCycleName,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.editable && _vm.result.nextMonth
                  ? _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-label-text", {
                          attrs: {
                            title: "차기법정예정월",
                            value: _vm.result.nextMonth,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.editable && _vm.result.relatedLawsName
                  ? _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-label-text", {
                          attrs: {
                            title: "관련법규",
                            value: _vm.result.relatedLawsName,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(
            "q-form",
            { ref: "editForm" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "설비 점검결과", bgClass: "" },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-select", {
                          attrs: {
                            label: "점검유형",
                            disabled: _vm.disabled,
                            required: "",
                            codeGroupCd: "MDM_CHECK_KIND_CD",
                            type: "edit",
                            itemText: "codeName",
                            itemValue: "code",
                            name: "equipmentCheckKindCd",
                          },
                          model: {
                            value: _vm.result.equipmentCheckKindCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "equipmentCheckKindCd", $$v)
                            },
                            expression: "result.equipmentCheckKindCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-field", {
                          attrs: {
                            disabled: _vm.disabled,
                            required: "",
                            label: "점검예정자",
                            name: "checkScheduleUserId",
                            type: "user",
                          },
                          model: {
                            value: _vm.result.checkScheduleUserId,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "checkScheduleUserId", $$v)
                            },
                            expression: "result.checkScheduleUserId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            required: "",
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            label: "점검예정일",
                            name: "checkScheduleDate",
                          },
                          model: {
                            value: _vm.result.checkScheduleDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "checkScheduleDate", $$v)
                            },
                            expression: "result.checkScheduleDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-field", {
                          attrs: {
                            disabled: _vm.disabled,
                            label: "실제점검자",
                            name: "checkUserId",
                            type: "user",
                          },
                          model: {
                            value: _vm.result.checkUserId,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "checkUserId", $$v)
                            },
                            expression: "result.checkUserId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            required: "",
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            label: "실제점검일",
                            name: "checkDate",
                          },
                          model: {
                            value: _vm.result.checkDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "checkDate", $$v)
                            },
                            expression: "result.checkDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            afterIcon: !_vm.disabled
                              ? [
                                  {
                                    name: "search",
                                    click: true,
                                    callbackName: "searchMocMaster",
                                    color: "teal",
                                  },
                                  {
                                    name: "close",
                                    click: true,
                                    callbackName: "removeMocMaster",
                                    color: "red",
                                  },
                                ]
                              : null,
                            editable: _vm.editable,
                            label: "MOC번호",
                            disabled: true,
                            name: "mocNo",
                          },
                          on: {
                            searchMocMaster: _vm.searchMocMaster,
                            removeMocMaster: _vm.removeMocMaster,
                          },
                          model: {
                            value: _vm.result.mocNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "mocNo", $$v)
                            },
                            expression: "result.mocNo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-select", {
                          attrs: {
                            codeGroupCd: "MIM_CHECK_RESULT_CD2",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            required: "",
                            type: "edit",
                            itemText: "codeName",
                            itemValue: "code",
                            name: "checkResultCd",
                            label: "점검결과",
                          },
                          model: {
                            value: _vm.result.checkResultCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "checkResultCd", $$v)
                            },
                            expression: "result.checkResultCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-plant", {
                          attrs: { disabled: _vm.disabled },
                          model: {
                            value: _vm.result.plantCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "plantCd", $$v)
                            },
                            expression: "result.plantCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-dept", {
                          attrs: { label: "점검부서", disabled: _vm.disabled },
                          model: {
                            value: _vm.result.checkDeptCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "checkDeptCd", $$v)
                            },
                            expression: "result.checkDeptCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("c-textarea", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            label: "점검결과요약",
                            name: "checkResultSummary",
                          },
                          model: {
                            value: _vm.result.checkResultSummary,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "checkResultSummary", $$v)
                            },
                            expression: "result.checkResultSummary",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c("c-tab", {
            attrs: {
              type: "tabcard",
              tabItems: _vm.tabItems,
              inlineLabel: true,
              align: "left",
            },
            on: {
              "update:tabItems": function ($event) {
                _vm.tabItems = $event
              },
              "update:tab-items": function ($event) {
                _vm.tabItems = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (tab) {
                  return [
                    _c(tab.component, {
                      tag: "component",
                      attrs: { result: _vm.result },
                    }),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.tab,
              callback: function ($$v) {
                _vm.tab = $$v
              },
              expression: "tab",
            },
          }),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }